(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ah-home"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ah-home-hero')) {
    customElements.define('ah-home-hero', class extends HTMLElement {
      connectedCallback() {
        const video = this.querySelector('video');
        if (!video || this.videoController) return;

        this.videoController = new AbortController();
        const options = { signal: this.videoController.signal };
        const viewport = window.matchMedia('(max-width: 749px)');
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        let activeSource = '';

        const syncVideo = () => {
          const src = viewport.matches ? video.dataset.mobileSrc : video.dataset.desktopSrc;
          video.poster = viewport.matches ? video.dataset.mobilePoster : video.dataset.desktopPoster;
          video.autoplay = !reducedMotion.matches;

          if (activeSource !== src) {
            video.src = src;
            video.load();
            activeSource = src;
          }

          if (reducedMotion.matches) {
            video.pause();
          } else {
            const playback = video.play();
            if (playback) playback.catch(() => {});
          }
        };

        video.addEventListener('error', () => {
          const fallback = viewport.matches ? video.dataset.mobileFallback : video.dataset.desktopFallback;
          if (!fallback || activeSource === fallback) return;
          video.src = fallback;
          video.load();
          activeSource = fallback;
          if (!reducedMotion.matches) {
            const playback = video.play();
            if (playback) playback.catch(() => {});
          }
        }, options);

        viewport.addEventListener('change', syncVideo, options);
        reducedMotion.addEventListener('change', syncVideo, options);
        syncVideo();
      }
      disconnectedCallback() {
        this.videoController?.abort();
        this.videoController = null;
        this.querySelector('video')?.pause();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ah-instagram"] && !Shopify.designMode) return;
  try {
    
(() => {
  const sections = document.querySelectorAll('.ah-social');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  sections.forEach(section => {
    if (section.dataset.motionReady) return;
    section.dataset.motionReady = 'true';
    const photos = section.querySelectorAll('.ah-social__photo');
    const factors = [-0.055, 0.05, -0.085, 0.075, -0.045];
    let scheduled = false;
    let visible = false;
    const update = () => {
      scheduled = false;
      const rect = section.getBoundingClientRect();
      const progress = (window.innerHeight - rect.top) / (window.innerHeight + rect.height) - 0.5;
      photos.forEach((photo, i) => {
        const limit = window.innerWidth < 700 ? 16 : 38;
        const drift = reduced.matches ? 0 : Math.max(-limit, Math.min(limit, progress * 1400 * factors[i % factors.length]));
        photo.style.setProperty('--ah-drift', drift.toFixed(2) + 'px');
      });
    };
    const schedule = () => {
      if (!scheduled && visible) { scheduled = true; requestAnimationFrame(update); }
    };
    const observer = new IntersectionObserver(entries => {
      visible = entries[0].isIntersecting;
      if (visible) schedule();
    }, { rootMargin: '100px' });
    observer.observe(section);
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    reduced.addEventListener('change', update);
    update();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (!customElements.get('ah-coat-reviews')) {
    customElements.define('ah-coat-reviews', class extends HTMLElement {
      connectedCallback() {
        this.update = () => {
          const rating = document.getElementById(this.dataset.ratingId);
          const widget = this.querySelector('#looxReviews');
          const frame = widget?.querySelector('iframe');
          const stars = rating?.querySelector('.loox-rating');
          const ready = Boolean(frame && frame.getBoundingClientRect().height > 0 && stars?.childElementCount);
          if (rating && rating.hidden !== !ready) rating.hidden = !ready;
          if (this.hasAttribute('data-ready') !== ready) this.toggleAttribute('data-ready', ready);
        };
        this.onRatingClick = (event) => {
          const rating = document.getElementById(this.dataset.ratingId);
          if (!rating || rating.hidden || !rating.contains(event.target)) return;
          event.preventDefault();
          event.stopPropagation();
          const bar = this.scope.querySelector('product-sticky-bar')?.getBoundingClientRect();
          const barHeight = bar && bar.top < window.innerHeight / 2 ? bar.height : 0;
          this.style.setProperty('--ah-review-sticky-height', `${barHeight}px`);
          this.focus({ preventScroll: true });
          this.scrollIntoView({ block: 'start', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        };
        this.scope = this.closest('.shopify-section') || this.parentElement;
        this.mutations = new MutationObserver(this.update);
        this.mutations.observe(this.scope, { childList: true, subtree: true });
        this.resize = new ResizeObserver(this.update);
        this.resize.observe(this);
        this.scope.addEventListener('click', this.onRatingClick, true);
        this.update();
      }

      disconnectedCallback() {
        this.mutations?.disconnect();
        this.resize?.disconnect();
        this.scope?.removeEventListener('click', this.onRatingClick, true);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
